import { render } from "./PatientsDatatableTDScan.vue?vue&type=template&id=7dc1057e&scoped=true"
import script from "./PatientsDatatableTDScan.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableTDScan.vue?vue&type=script&lang=js"

import "./PatientsDatatableTDScan.vue?vue&type=style&index=0&id=7dc1057e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc1057e"]])

export default __exports__